export enum FormaPagemento {
  DEBITO_CONTA = "DEBITO_CONTA",
  CARTAO_CREDITO = "CARTAO_CREDITO",
}
